import BarrelHelpers from "../../apps/data/barrel/BarrelHelpers";

import { StoreProps } from "./VariableContainerProps";

export function mapStateToProps(): StoreProps {
    const platform = BarrelHelpers.getPlatform();

    return {
        platform
    };
}
